import Component from '@glimmer/component';
import { t } from 'ember-intl';
import DonutChart from 'tio-reimagined/components/charts/donut-chart';
import type LoanModel from 'tio-data/models/loan';

export interface LoanSummaryChartSignature {
  Args: {
    loans: LoanModel[];
  };
}

const LOAN_COLORS = [
  '#10B981', // emerald-500
  '#F59E0B', // amber-500
  '#EF4444', // red-500
  '#8B5CF6', // violet-500
  '#06B6D4', // cyan-500
  '#F97316', // orange-500
  '#84CC16', // lime-500
  '#3B82F6', // blue-500
];

export default class LoanSummaryChart extends Component<LoanSummaryChartSignature> {
  get chartData() {
    return this.args.loans
      .filter((loan) => loan.currentBalance && loan.currentBalance > 0)
      .map((loan) => ({
        category: loan.name ?? `Loan ${loan.id}`,
        value: loan.currentBalance,
      }));
  }

  <template>
    {{#if this.chartData.length}}
      <DonutChart
        @data={{this.chartData}}
        @colors={{LOAN_COLORS}}
        @showLegend={{false}}
        data-test-loan-summary-chart
        class="h-full w-full"
      />
    {{else}}
      <div class="min-h-64 w-full flex justify-center items-center">
        <div class="tio-fg-muted text-center">
          <div class="text-sm">{{t "no_chart_data"}}</div>
        </div>
      </div>
    {{/if}}
  </template>
}
